<template>
  <RevContainer class="py-32">
    <section class="flex flex-col items-center gap-24 md:flex-row md:gap-48">
      <div class="flex w-full flex-col gap-24 md:w-1/2">
        <header class="flex flex-col gap-8">
          <h1 class="heading-1">{{ i18n(translations.heading) }}</h1>
          <p>
            {{ i18n(translations.firstParagraph) }}
          </p>
        </header>

        <FormattedMessage :definition="translations.secondParagraph" tag="p">
          <template #profileLink>
            <RevLink
              :to="resolveLocalizedRoute({ name: ROUTE_NAMES.DASHBOARD.SELF })"
            >
              {{ i18n(translations.profileLink) }}
            </RevLink>
          </template>
        </FormattedMessage>
      </div>

      <RevIllustration
        alt=""
        class="w-full md:w-1/2"
        :height="170"
        src="/img/person-relaxing-grass-headphones.png"
        :width="327"
      />
    </section>
  </RevContainer>
</template>

<script lang="ts" setup>
import { useRouteLocationWithLocale } from '#imports'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import { ROUTE_NAMES } from '~/scopes/dashboard/constants'

import translations from './UsedError.translations'

const resolveLocalizedRoute = useRouteLocationWithLocale()

const i18n = useI18n()
</script>
